import { Component, OnInit } from '@angular/core';
import { ChecklistCategoriesVM } from '../../entities/global/model';
import { SafetyConfigService } from '../../services/safety-config.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-config-setup-checklist-add-new-category-dialog',
  templateUrl: './config-setup-checklist-add-new-category-dialog.component.html',
  styleUrls: ['./config-setup-checklist-add-new-category-dialog.component.css']
})
export class ConfigSetupChecklistAddNewCategoryDialogComponent implements OnInit {

  selectedName:any;
  selectedDescription:any;


  constructor(
    public dialogRef:MatDialogRef<ConfigSetupChecklistAddNewCategoryDialogComponent>,
    private _safetyConfigService:SafetyConfigService,
   // private _mainetec:MainetecService,
  ) { }

  ngOnInit() {
  }

  DialogClose(){
    this.dialogRef.close(false)
  }

  CreateCategory(){
    let model= new ChecklistCategoriesVM()
    model.CategoryName=this.selectedName;
    model.CategoryDescription=this.selectedDescription
this._safetyConfigService.addCategory(model).subscribe((res: any) =>{
 
  if(res){
    console.log('result', res)
    this.DialogClose();
   
  }
  
})

 }



}
